import { render, staticRenderFns } from "./ScreeningProcessFlags.vue?vue&type=template&id=491f1178&"
import script from "./ScreeningProcessFlags.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491f1178')) {
      api.createRecord('491f1178', component.options)
    } else {
      api.reload('491f1178', component.options)
    }
    module.hot.accept("./ScreeningProcessFlags.vue?vue&type=template&id=491f1178&", function () {
      api.rerender('491f1178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/ScreeningProcessFlags.vue"
export default component.exports